"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectObjectContentInput_1 = require("./SelectObjectContentInput");
var SelectObjectContentOutput_1 = require("./SelectObjectContentOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.SelectObjectContent = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "SelectObjectContent",
    http: {
        method: "POST",
        requestUri: "/{Bucket}/{Key+}?select&select-type=2"
    },
    input: {
        shape: SelectObjectContentInput_1.SelectObjectContentInput,
        locationName: "SelectObjectContentRequest",
        xmlNamespace: {
            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
        }
    },
    output: {
        shape: SelectObjectContentOutput_1.SelectObjectContentOutput
    },
    errors: []
};
//# sourceMappingURL=SelectObjectContent.js.map